module.exports = __webpack_public_path__ + "assets-cabinet/img/list-menu-icon.0a5a16a5.svg";